import { motion } from "framer-motion";
import StoreButtons from "@/components/landing/StoreButtons";

export default function Footer() {
    return (
        <footer data-testid="footer" className="relative border-t border-white/5 mt-20">
            {/* CTA band */}
            <div className="relative overflow-hidden">
                <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(0,240,255,0.18),transparent_60%),radial-gradient(ellipse_at_bottom_right,rgba(255,45,146,0.15),transparent_60%)]" />
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                    className="relative max-w-7xl mx-auto px-5 sm:px-8 py-24 text-center"
                >
                    <h3 className="font-display font-semibold text-4xl sm:text-6xl leading-[1.02] tracking-tight max-w-3xl mx-auto">
                        <span className="grad-text">Yola çıkmaya hazır mısın?</span>
                    </h3>
                    <p className="mt-5 text-white/60 max-w-xl mx-auto">
                        Uygulamayı indir, ilk rotanı kur. Planlama bir dakikada biter.
                    </p>
                    <div className="mt-8 flex justify-center">
                        <StoreButtons />
                    </div>
                </motion.div>
            </div>

            {/* Bottom row */}
            <div className="border-t border-white/5">
                <div className="max-w-7xl mx-auto px-5 sm:px-8 py-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
                    <div className="flex items-center gap-2.5">
                        <span className="w-8 h-8 rounded-lg bg-[#111115] border border-white/10 flex items-center justify-center">
                            <svg viewBox="0 0 32 32" className="w-5 h-5">
                                <path d="M6 24 C 12 16, 18 16, 26 8" stroke="#00F0FF" strokeWidth="2.5" fill="none" strokeLinecap="round" />
                                <circle cx="26" cy="8" r="3" fill="#FF2D92" />
                            </svg>
                        </span>
                        <div>
                            <div className="font-display font-semibold text-sm">YolArkadaşım</div>
                            <div className="text-[11px] text-white/40">HGS & Rota Hesap</div>
                        </div>
                    </div>

                    <div className="flex items-center gap-6 text-sm text-white/55">
                        <a href="#" className="hover:text-white transition-colors">Gizlilik</a>
                        <a href="#" className="hover:text-white transition-colors">Koşullar</a>
                        <a href="#" className="hover:text-white transition-colors">İletişim</a>
                        <a href="#" className="hover:text-white transition-colors">Basın</a>
                    </div>

                    <div className="flex items-center gap-2">
                        {[
                            { label: "Instagram", path: "M12 2.2c3.2 0 3.6 0 4.9.1 1.2.1 1.8.3 2.3.5a3.9 3.9 0 0 1 2.2 2.2c.2.5.4 1.1.5 2.3 0 1.3.1 1.7.1 4.9s0 3.6-.1 4.9c-.1 1.2-.3 1.8-.5 2.3a3.9 3.9 0 0 1-2.2 2.2c-.5.2-1.1.4-2.3.5-1.3 0-1.7.1-4.9.1s-3.6 0-4.9-.1c-1.2-.1-1.8-.3-2.3-.5a3.9 3.9 0 0 1-2.2-2.2c-.2-.5-.4-1.1-.5-2.3 0-1.3-.1-1.7-.1-4.9s0-3.6.1-4.9c.1-1.2.3-1.8.5-2.3A3.9 3.9 0 0 1 4.8 2.8c.5-.2 1.1-.4 2.3-.5C8.4 2.2 8.8 2.2 12 2.2zm0 5.4a4.4 4.4 0 1 0 0 8.8 4.4 4.4 0 0 0 0-8.8zm5.5-.2a1 1 0 1 0 0 2.1 1 1 0 0 0 0-2.1zM12 9.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5z" },
                            { label: "X", path: "M17.5 3h3.1l-6.8 7.8L22 21h-6.3l-4.9-6.4L5 21H1.9l7.3-8.3L1.6 3h6.5l4.5 5.9L17.5 3zm-1.1 16.1h1.7L7.7 4.8H5.9l10.5 14.3z" },
                            { label: "TikTok", path: "M16 3c.4 2.6 2 4.3 4.5 4.5v3.2c-1.4 0-2.7-.4-4-1.1v6.7a5.9 5.9 0 1 1-6-5.9v3.2a2.7 2.7 0 1 0 2.7 2.7V3H16z" },
                        ].map((s) => (
                            <a
                                key={s.label}
                                href="#"
                                aria-label={s.label}
                                className="w-9 h-9 rounded-full border border-white/10 bg-white/5 hover:border-[#00F0FF]/40 hover:text-[#00F0FF] text-white/70 flex items-center justify-center transition-colors"
                            >
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                                    <path d={s.path} />
                                </svg>
                            </a>
                        ))}
                    </div>
                </div>

                <div className="max-w-7xl mx-auto px-5 sm:px-8 pb-10 text-[11px] text-white/35">
                    © {new Date().getFullYear()} YolArkadaşım. Tüm hakları saklıdır.
                </div>
            </div>
        </footer>
    );
}
